import React from "react";
import {
  Link,
} from "react-router-dom";
import Logo from "../images/tomo_logo_blk_grn.svg";
import SocialLinks from "../common/SocialLinks";

const Footer = () => (
  <footer>
    <div className="pt-20 sm:pt-32 pb-10 md:pb-20 footer w-full text-left">
      <div className="max-w-page sm:flex sm:justify-between  w-full px-8">
        <div className="mb-10 md:mb-0 text-dark px-3">
          <Link to="/">
            <img alt="" className="m-0 pb-2" src={Logo} />
          </Link>
          <ul className="mt-5">
            <li><Link to="/privacypolicy">Privacy Policy</Link></li>
            <li><a href="https://tomo-public-docs.s3.us-west-1.amazonaws.com/TermsOfUse.pdf">Terms of Use</a></li>
            <li><Link to="/legal">Legal</Link></li>
          </ul>
        </div>

        <div className="text-dark mb-10 px-3">
          <h5 className="font-bold mb-2 text-dark text-xl">Product</h5>
          <ul className="mt-5">
            <li><a href="/dashboard">Login</a></li>
            <li><Link to="/faq">FAQs</Link></li>
            <li><Link to="/support">Support</Link></li>
            <li><Link to="/application-troubleshooting">Application Help</Link></li>
          </ul>

        </div>

        <div className="text-dark mb-10 px-3">
          <h5 className="font-bold mb-2 text-dark text-xl">Company</h5>
          <ul className="mt-5">
            <li><Link to="/about">About</Link></li>
            <li><Link to="/careers">Careers</Link></li>
            <li><a href="https://tomocredit.com/blog/">Blog</a></li>
            <li><Link to="/ambassador">Ambassador</Link></li>
            <li><a href="https://www.flexoffers.com/affiliate-programs/tomoboost-affiliate-program/">Affiliate</a></li>
          </ul>

        </div>

        <div className="mb-10 px-3">
          <h5 className="font-bold mb-2 text-dark text-xl">Get in touch</h5>
          <a href="mailto:help@tomocredit.com">
            <p className="font-text text-dark mb-3">help@tomocredit.com</p>
          </a>
          <SocialLinks className="-ml-2 text-dark" />
          {/*
            <SocialShares
            className="flex justify-center sm:justify-start md:-ml-1"
            url="tomocredit.com"
          />
          */}
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
